import styled from '@emotion/styled';
import { css } from '@emotion/core';
import {
	BaseCell,
	BaseHeader,
} from '../../../../flights/overview/ui/list/columns/Column';
import { Css, Responsive } from '../../../../../ui';
import { Color } from '../../../../../styles/Color';
import { solicitationListHeaderStyles } from './Column.styles';

interface ISolicitationTitleProps {
	title: string;
}

const styles = css`
	display: flex;
	width: 264px;
	max-width: 264px;
	margin-right: ${Css.pxToRem(40)};
	padding: 0;

	@media (${Responsive.getMediaQueryForBreakpoint('tablet')}) {
		margin-right: 0;
		padding-right: 0;
	}
`;

const StyledHeader = styled(BaseHeader)`
	${styles}
	${solicitationListHeaderStyles}
	color: ${Color.Neutral6};

	@media (${Responsive.getMediaQueryForBreakpoint('tablet')}) {
		padding-right: 0;
		margin-right: 0;
	}
`;

const StyledCell = styled(BaseCell)`
	${styles}
	padding: 0;

	@media (${Responsive.getMediaQueryForBreakpoint('mobileXL')}) {
		grid-area: title;
		max-width: ${Css.pxToRem(147)};
	}
`;

const Column = styled.div`
	display: flex;
	flex-direction: column;

	@media (${Responsive.getMediaQueryForBreakpoint('tablet')}) {
		word-break: break-word;
	}
`;

const SolicitationTitleName = styled.span`
	font-weight: 500;
	font-size: ${Css.pxToRem(16)};
	line-height: ${Css.pxToRem(19)};

	@media (${Responsive.getMediaQueryForBreakpoint('tablet')}) {
		max-width: 130px;
		min-width: fit-content;
		width: 130px;
	}
`;

export function Header() {
	return <StyledHeader>Project Name</StyledHeader>;
}

export function Cell({ title }: ISolicitationTitleProps) {
	return (
		<StyledCell>
			<Column>
				<SolicitationTitleName>{title}</SolicitationTitleName>
			</Column>
		</StyledCell>
	);
}
